<template>
  <div>
    <transition name="fade">
      <div
        v-if="activeModal"
        class="z-100 1backdrop-blur-xs fixed left-0 top-0 h-[var(--app-height)] w-full bg-black/50 dark:bg-black/80"
        @click="closeActiveModal"
      ></div>
    </transition>
    <transition name="slide-fade">
      <div
        v-if="activeModal"
        class="z-101 pointer-events-none fixed left-0 top-0 flex h-[var(--app-height)] w-full items-end justify-center p-1 md:items-center md:p-2"
      >
        <component
          :is="getModalComponent(activeModal.type)"
          :key="activeModal.uuid"
          :modal="activeModal"
          class="pointer-events-auto"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import OrderModal from './templates/OrderModal.vue';
import CallbackModal from './templates/CallbackModal.vue';
import CatalogSelectModal from './templates/CatalogSelectModal.vue';
import FilterModal from './templates/FilterModal.vue';
import ErrorModal from './templates/ErrorModal.vue';
import SuccessCrmLinkModal from './templates/SuccessCrmLinkModal.vue';
export default {
  components: {
    OrderModal,
    CallbackModal,
    CatalogSelectModal,
    FilterModal,
    SuccessCrmLinkModal,
    ErrorModal,
  },

  computed: {
    ...mapGetters(['activeModal', 'modalTypes', 'modalCount']),
  },

  created() {
    window.eventBus.$on('modal:open', () => {
      document.body.classList.add('body-modal-opened');
    });

    window.eventBus.$on('modal:close', () => {
      if (this.modalCount === 0) {
        document.body.classList.remove('body-modal-opened');
      }
    });

    window.eventBus.$on('modal:closeAll', () => {
      document.body.classList.remove('body-modal-opened');
    });
  },

  beforeDestroy() {
    window.eventBus.$off('modal:open');
    window.eventBus.$off('modal:close');
    window.eventBus.$off('modal:closeAll');
    this.CLOSE_ALL_MODALS();
  },

  methods: {
    ...mapActions(['CLOSE_ALL_MODALS', 'CLOSE_MODAL']),
    getModalComponent(type) {
      return this.modalTypes[type]?.component || null;
    },
    closeActiveModal() {
      window.eventBus.$emit('modal:mask-close');
    },
  },
};
</script>

<style lang="scss">
.body-modal-opened {
  overflow: hidden;
}
</style>
